import Request from "../../../shared/helpers/request";

const AnexosIApi = {
  Save: data => {
    return Request
      .post('anexov', data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  },
  Edit: data => {
    return Request
      .put('anexov', data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  },
  Delete: data => {
    return Request
      .delete('anexov', data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }
}

export default AnexosIApi;